
namespace TabAurous.Common {

  
    @Serenity.Decorators.registerClass()
    export class ReturnOrderItemsSelectGrid extends _Ext.GridBase<ECommerce.ECommOrderItemsRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrderItems'; }
        protected getDialogType() { return ECommerce.ECommOrderItemsDialog; }
        protected getIdProperty() { return ECommerce.ECommOrderItemsRow.idProperty; }
        protected getInsertPermission() { return ECommerce.ECommOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommerce.ECommOrderItemsRow.localTextPrefix; }
        protected getService() { return ECommerce.ReturnOrderItemsSelectService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {}; 
        withBom: boolean; 
     
        //withBom: boolean;
        constructor(container: JQuery, options) {
            super(container,options);
            var request = this.view.params as ReportFiltersRequest;
            var poscustomerid = options.GridFilters.CustomerId;
            if (poscustomerid != undefined && poscustomerid > 0) {
                (this.view.params as TransactionRequest).POSCustomerId = poscustomerid;
            } 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): ECommerce.ECommOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        } 

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}